module.exports = __webpack_public_path__ + "img/NDTVRaftarInter.58c27e7d.jpg";